import $ from 'jquery';
import { initProductCrossSell } from '../../single-product/product-cross-sell';

const dialog = document.querySelector('#added-to-cart-popup');

if (dialog && typeof dialog.showModal === 'function') {
    const body = dialog.querySelector('[data-confirmation-body]');
    const footer = dialog.querySelector('[data-confirmation-footer]');
    const closeButton = dialog.querySelector('.AddedToCartPopup__close');
    const summary = dialog.querySelector('[data-confirmation-summary]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let controller = null;
    let request = null;
    let returnFocus = null;
    let closeTimer = null;
    let afterClose = null;
    let active = false;
    let closing = false;
    let backdropPointer = false;
    let revealTimer = null;
    let viewAnimation = null;
    let summaryAnimation = null;
    let lastSubtotal = '';
    let scrollPosition = 0;
    let previousBodyStyle = null;
    let frameAnimation = null;
    let frameRequest = null;
    let recommendationsScrollTop = 0;
    let contentObserver = null;

    const updateScrollHint = () => {
        const hint = body.querySelector('[data-confirmation-scroll-hint]');
        if (!hint) return;
        const position = body.scrollTop;
        // Measure without the hint so it cannot create the overflow it describes.
        hint.hidden = true;
        if (active && !dialog.classList.contains('is-picking')) hint.hidden = body.scrollHeight <= body.clientHeight + 1;
        body.scrollTop = position;
    };

    const measureFrame = () => {
        const height = dialog.offsetHeight;
        cancelAnimationFrame(frameRequest);
        frameAnimation?.cancel();
        return height;
    };
    const resizeFrame = (previousHeight) => {
        if (!previousHeight || !active || closing || reducedMotion.matches) return;
        // The inline picker opens just after its callback; measure on the next frame.
        frameRequest = requestAnimationFrame(() => {
            frameRequest = null;
            if (!active || closing || reducedMotion.matches) return;
            const height = dialog.offsetHeight;
            if (Math.abs(height - previousHeight) < 2) return;
            frameAnimation = dialog.animate([{ height: `${previousHeight}px` }, { height: `${height}px` }], {
                duration: 260, easing: 'cubic-bezier(.22, 1, .36, 1)',
            });
        });
    };

    const revealView = (direction = 1) => {
        viewAnimation?.cancel();
        if (reducedMotion.matches || !active) return;
        viewAnimation = body.animate([
            { opacity: .35, transform: `translateX(${direction * 8}px)` },
            { opacity: 1, transform: 'none' },
        ], { duration: 220, easing: 'cubic-bezier(.22, 1, .36, 1)' });
    };

    const cancelRead = () => {
        const pending = request;
        request = null;
        if (pending) pending.abort();
    };
    const setBusy = (busy) => {
        closeButton.disabled = busy;
        footer.inert = busy;
    };
    const updateSummary = (data) => {
        if (typeof data?.cart_subtotal !== 'string') return;
        dialog.querySelector('[data-confirmation-count]').textContent = data.cart_count;
        dialog.querySelector('[data-confirmation-subtotal]').innerHTML = data.cart_subtotal;
        summary.hidden = false;
        if (lastSubtotal && lastSubtotal !== data.cart_subtotal && !footer.hidden && !reducedMotion.matches) {
            summaryAnimation?.cancel();
            summaryAnimation = summary.animate([{ backgroundColor: '#edf5ef' }, { backgroundColor: 'transparent' }], { duration: 650, easing: 'ease-out' });
        }
        lastSubtotal = data.cart_subtotal;
    };
    const cleanup = () => {
        if (!active) return;
        active = false;
        cancelRead();
        clearTimeout(closeTimer);
        clearTimeout(revealTimer);
        cancelAnimationFrame(frameRequest);
        frameAnimation?.cancel();
        viewAnimation?.cancel();
        summaryAnimation?.cancel();
        contentObserver?.disconnect();
        contentObserver = null;
        controller?.destroy();
        controller = null;
        dialog.classList.remove('is-closing', 'is-picking', 'is-loading', 'is-revealing');
        dialog.inert = false;
        closing = false;
        document.documentElement.classList.remove('has-cart-confirmation');
        if (previousBodyStyle === null) document.body.removeAttribute('style');
        else document.body.setAttribute('style', previousBodyStyle);
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        const target = returnFocus?.isConnected ? returnFocus : document.querySelector('#open-cart-btn');
        target?.focus({ preventScroll: true });
        const next = afterClose;
        afterClose = null;
        if (next) next();
    };
    const finishClose = () => {
        dialog.close();
        cleanup();
    };
    const close = (next = null) => {
        if (!dialog.open || closing || controller?.isBusy()) return;
        afterClose = next;
        cancelRead();
        if (reducedMotion.matches) { finishClose(); return; }
        // Escape can interrupt the entrance; leave from the current frame, without a jump.
        const frame = getComputedStyle(dialog);
        dialog.style.setProperty('--confirmation-close-opacity', frame.opacity);
        dialog.style.setProperty('--confirmation-close-transform', frame.transform);
        dialog.style.setProperty('--confirmation-backdrop-opacity', getComputedStyle(dialog, '::backdrop').opacity);
        closing = true;
        dialog.inert = true;
        dialog.classList.add('is-closing');
        closeTimer = setTimeout(finishClose, 260);
    };
    const load = (animate = false) => {
        const previousHeight = measureFrame();
        cancelRead();
        contentObserver?.disconnect();
        contentObserver = null;
        controller?.destroy();
        controller = null;
        setBusy(false);
        clearTimeout(revealTimer);
        dialog.classList.remove('is-compact', 'is-revealing');
        dialog.classList.add('is-loading');
        body.hidden = false;
        body.setAttribute('aria-busy', 'true');
        body.replaceChildren(dialog.querySelector('[data-confirmation-loading]').content.cloneNode(true));
        if (animate) resizeFrame(previousHeight);
        const current = $.ajax({
            url: jsData.ajaxUrl, type: 'GET', dataType: 'json', cache: false, timeout: 20000,
            data: { action: 'verenza_get_cart_items', view: 'added_to_cart' },
        });
        request = current;
        const fail = () => {
            const previousHeight = measureFrame();
            summary.hidden = true;
            dialog.classList.add('is-compact');
            body.innerHTML = '<p class="AddedToCartPopup__status" role="alert">Produkt jest już w koszyku. Nie udało się wczytać propozycji dodatków.</p><button type="button" class="Button--no-style AddedToCartPopup__retry" data-confirmation-retry>Wczytaj ponownie</button>';
            resizeFrame(previousHeight);
        };
        current.done((data) => {
            if (request !== current || !dialog.open) return;
            if (typeof data?.confirmation_html !== 'string' || typeof data.cart_html !== 'string') { fail(); return; }
            const previousHeight = measureFrame();
            body.innerHTML = data.confirmation_html;
            body.scrollTop = 0;
            recommendationsScrollTop = 0;
            const section = body.querySelector('.ProductCrossSell');
            body.hidden = !section;
            dialog.classList.toggle('is-compact', body.querySelectorAll('[data-cross-sell-card]').length < 2);
            // Prioritize the first screen; offscreen recommendations keep lazy images.
            body.querySelectorAll('[data-cross-sell-card]').forEach((card, index) => {
                if (index < (window.matchMedia('(min-width: 900px)').matches ? 4 : 2)) {
                    card.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
                }
            });
            if (section) controller = initProductCrossSell(section, {
                inlinePicker: true,
                compactActions: true,
                onPickerToggle: (open) => {
                    const previousHeight = measureFrame();
                    if (open) recommendationsScrollTop = body.scrollTop;
                    clearTimeout(revealTimer);
                    dialog.classList.remove('is-revealing');
                    section.classList.toggle('is-picking', open);
                    dialog.classList.toggle('is-picking', open);
                    footer.hidden = open;
                    updateScrollHint();
                    body.scrollTop = open ? 0 : recommendationsScrollTop;
                    revealView(open ? 1 : -1);
                    resizeFrame(previousHeight);
                },
                onBusy: setBusy,
            });
            if (section) {
                updateScrollHint();
                contentObserver = new ResizeObserver(updateScrollHint);
                contentObserver.observe(body);
                contentObserver.observe(section);
            }
            dialog.classList.add('is-revealing');
            revealTimer = setTimeout(() => dialog.classList.remove('is-revealing'), 420);
            updateSummary(data);
            resizeFrame(previousHeight);
            $(document.body).trigger('ravessa:cart-updated', [data]);
        }).fail((xhr, result) => {
            if (request === current && result !== 'abort') fail();
        }).always(() => {
            if (request !== current) return;
            request = null;
            dialog.classList.remove('is-loading');
            body.setAttribute('aria-busy', 'false');
        });
    };
    const open = (button) => {
        if (controller?.isBusy()) return;
        const wasOpen = dialog.open;
        document.dispatchEvent(new CustomEvent('ravessa:close-cart'));
        clearTimeout(closeTimer);
        closing = false;
        afterClose = null;
        dialog.inert = false;
        dialog.classList.remove('is-closing');
        if (!dialog.open) {
            returnFocus = button?.[0] || document.activeElement;
            scrollPosition = window.scrollY;
            previousBodyStyle = document.body.getAttribute('style');
            Object.assign(document.body.style, { position: 'fixed', top: `-${scrollPosition}px`, left: '0', right: '0', width: '100%' });
            active = true;
            dialog.showModal();
            document.documentElement.classList.add('has-cart-confirmation');
            closeButton.focus({ preventScroll: true });
        }
        summary.hidden = true;
        lastSubtotal = '';
        footer.hidden = false;
        load(wasOpen);
    };
    const dismiss = (event) => {
        event.preventDefault();
        if (controller?.isPickerOpen()) controller.closePicker();
        else close();
    };
    // An inline nonmodal dialog can consume the browser's native Escape request.
    dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        dismiss(event);
    });
    dialog.addEventListener('cancel', dismiss);
    dialog.addEventListener('close', () => {
        if (!dialog.open) cleanup();
    });
    dialog.addEventListener('animationend', (event) => {
        if (closing && event.target === dialog && event.animationName === 'cart-confirmation-out') finishClose();
    });
    const isBackdrop = (event) => {
        if (event.target !== dialog) return false;
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    dialog.addEventListener('pointerdown', (event) => { backdropPointer = isBackdrop(event); });
    dialog.addEventListener('click', (event) => {
        if ((backdropPointer && isBackdrop(event)) || event.target.closest('[data-confirmation-close]')) close();
        if (event.target.closest('[data-confirmation-cart]')) close(() => document.dispatchEvent(new CustomEvent('ravessa:open-cart')));
        if (event.target.closest('[data-confirmation-retry]')) load(true);
        backdropPointer = false;
    });
    $(document.body).on('added_to_cart.ravessaConfirmation', (event, fragments, hash, button) => open(button));
    $(document.body).on('ravessa:cart-updated.ravessaConfirmation', (event, data) => {
        if (dialog.open) updateSummary(data);
    });
    dialog.dataset.ready = 'true';
}
